import { useContext } from 'react';

import SidebarContext, { SidebarContext as ISidebarContext } from './Sidebar.context';

export const useSidebarContext = () => useContext(SidebarContext) as ISidebarContext;
